/* eslint-disable prefer-rest-params */
import App, { AppContext } from 'next/app';
import React, { ErrorInfo } from 'react';
import { Provider } from 'react-redux';
import createStore from '../store';
import './index.scss';

const isServer = typeof window === 'undefined';
if (isServer) {
  // not print in back end, such as in vscode
  // console.log = () => { };
}

class MyApp extends App {
  static async getInitialProps(appContext: AppContext) {
    const appProps = await App.getInitialProps(appContext);
    return { ...appProps };
  }

  store;

  constructor(props: { pageProps: { data: object } }) {
    super(props);
    const { data = {} } = props.pageProps;
    this.store = createStore(data);
    globalThis.$getState = this.store.getState;
    //@ts-ignore
    globalThis.$dispatch = this.store.dispatch;
    String.prototype.format = function () {
      let str = this.toString();
      if (!arguments.length) {
        return str;
      }
      let args = typeof arguments[0];
      args = args === 'string' || args === 'number' ? arguments : arguments[0];
      //@ts-ignore
      for (const arg in args) {
        if (Object.prototype.hasOwnProperty.call(args, arg)) {
          const replace = args[arg] ? args[arg] : '';
          str = str.replace(RegExp('\\{' + arg + '\\}', 'gi'), replace);
        }
      }
      return str;
    };
  }

  componentDidCatch(e: Error, info: ErrorInfo) {
    // log error on console with info and error
    console.error('_app.js componentDidCatch e', e, 'info', info);
  }

  render() {
    const { Component, pageProps } = this.props;

    return (
      <Provider store={this.store}>
        <Component {...pageProps} />
      </Provider>
    );
  }
}

export default MyApp;
